var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertErrorMessageWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.7 56.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fee218;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.9,43.8L33.5,9.7c-.9-1.7-2.7-2.7-4.6-2.7s-3.7,1-4.6,2.7L4.8,43.8c-.9,1.6-.9,3.7,0,5.3,1,1.6,2.7,2.6,4.6,2.6h38.8c1.9,0,3.6-1,4.6-2.6,1-1.6,1-3.7,0-5.3ZM31.5,45.5c-.6.6-1.4.9-2.3.9s-1.7-.3-2.3-.9c-.7-.6-1-1.4-1-2.4s.3-1.7,1-2.3c.6-.6,1.4-1,2.3-1s1.7.3,2.4,1c.6.6,1,1.4,1,2.3,0,1-.3,1.8-1,2.4ZM32.4,23.5l-.8,9.7c0,1.2-.3,2.1-.6,2.8-.4.7-1,1.1-1.8,1.1s-1.5-.4-1.8-1.1c-.3-.6-.5-1.6-.6-2.8l-.6-9.4c-.1-1.9-.2-3.2-.2-4,0-1.2.3-2.1.9-2.8.6-.7,1.5-1,2.5-1s2.1.5,2.6,1.4c.4.8.6,2,.6,3.5,0,.9,0,1.8-.1,2.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertErrorMessageWarning);
export default __webpack_public_path__ + "static/media/alertErrorMessageWarning.e52b57221cdda26a78bb34a41d873a89.svg";
export { ForwardRef as ReactComponent };